package features.timeoff.ui.modals

import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import shared.ui.ModalManager

object ManageCategoriesModal {
    fun render(root: HTMLElement) {
        root.append {
            div("modal-content fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-dark-800 border border-dark-700 rounded-2xl p-6 w-full max-w-2xl z-[101] hidden shadow-2xl h-[85vh] flex flex-col") {
                id = "manage-categories-modal"
                
                div("flex justify-between items-center mb-6 flex-shrink-0") {
                    h3("text-xl font-bold") { +"Manage Leave Categories" }
                    button(classes = "text-slate-400 hover:text-white") {
                        onClickFunction = { ModalManager.close() }
                        +"✕"
                    }
                }
                
                div("flex-1 overflow-y-auto pr-2 custom-scrollbar space-y-4 mb-6") {
                    // Add Category
                    div("bg-dark-900 p-4 rounded-xl border border-dark-700 mb-6") {
                        h4("font-bold mb-3 text-white") { +"Add New Category" }
                        div("flex gap-3") {
                            select("bg-dark-800 border border-dark-700 rounded-lg p-2 text-white flex-1") {
                                id = "category-type-select"
                                // Options will be populated dynamically from leave types
                            }
                            input(classes = "bg-dark-800 border border-dark-700 rounded-lg p-2 text-white flex-1") {
                                id = "category-name-input"
                                placeholder = "Category Name (e.g. Test1)"
                            }
                            button(classes = "bg-brand-cyan text-white px-4 rounded-lg font-bold hover:bg-brand-green transition") {
                                attributes["onclick"] = "addLeaveCategory()"
                                +"Add"
                            }
                        }
                    }
                    
                    div("space-y-3") {
                        id = "categories-list"
                        // List will be populated dynamically
                    }
                    
                    // Add New Type
                    div("border-t border-dark-700 pt-6 mt-6") {
                        button(classes = "text-slate-400 hover:text-brand-green flex items-center gap-2 text-sm font-medium w-full") {
                            onClickFunction = { 
                                val form = document.getElementById("add-type-form")
                                form?.classList?.toggle("hidden")
                            }
                            span { +"+" }
                            +"Add New Leave Type"
                        }
                        
                        div("mt-4 hidden space-y-3 bg-dark-900 p-4 rounded-xl") {
                            id = "add-type-form"
                            input(classes = "w-full bg-dark-800 border border-dark-700 rounded-lg p-2 text-white") {
                                id = "leave-type-name-input"
                                placeholder = "Type Name (e.g. Oilah)"
                            }
                            div("flex items-center gap-3") {
                                input(type = InputType.number, classes = "bg-dark-800 border border-dark-700 rounded-lg p-2 text-white w-24") {
                                    id = "leave-type-quota-input"
                                    value = "15"
                                }
                                span("text-sm text-slate-500") { +"Default Quota (0 for unlimited/unpaid)" }
                            }
                            button(classes = "w-full bg-slate-700 hover:bg-slate-600 text-white py-2 rounded-lg font-bold transition") {
                                attributes["onclick"] = "createLeaveType()"
                                +"Create Type"
                            }
                        }
                    }
                }
            }
        }
    }
}
